/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext } from "react";
import { Td, Tr, Button, Box } from "@chakra-ui/react";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";
import environment from "constants/apiConst";
import DianCRUDContext from "context/DianCrudContext";
import { useSelector } from "react-redux";
import { __PostForm } from "request/Petitions/__Post";
import { useNavigate } from "react-router-dom";

const TbodyItemsProfile = ({ data }) => {
  const token = useSelector((state) => state.auth.dataUser.token);
  const [openAlert] = AlertErrorAlert();
  const navigate = useNavigate();

  const { dataFormItems, setUpdate, setLoading, update, loading } =
    useContext(DianCRUDContext);

  const handleChange = async (dialType) => {
    const dataUpdateDocumentItem = new FormData();
    dataUpdateDocumentItem.append(
      "document_type",
      dataFormItems?.document_type
    );
    dataUpdateDocumentItem.append("form_id", dataFormItems?.form_id);
    dataUpdateDocumentItem.append("dial_type", dialType);
    dataUpdateDocumentItem.append("form_item_id", data?.id);
    
    setLoading(true);
    try {
      const res = await __PostForm(
        environment.DOCUMETS_PROFILE_ITEMS,
        token,
        dataUpdateDocumentItem
      );
      if (res?.data?.status?.code === 200) {
        setUpdate(!update);
        if (dialType === "No") {
          navigate("/Perfilardocumento?movement=Perfilar%20Documentos");
        }
      } else {
        openAlert(res.data.status.message, "error");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <Tr className={"verticalNone"}>
      <Td className="text-center">{data?.code_subheading}</Td>
      <Td className="text-center">{data?.description_product}</Td>
      <Td className="text-center">{data?.product_quantity}</Td>
      <Td className="text-center">{data?.code_businessUnit}</Td>
      <Td className="text-center">{data?.gross_weight}</Td>

      <Td
        style={{
          width: "17%",
          paddingLeft: "13px"
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          gap={{ base: "10px", md: "8px" }}
          width="100%"
          marginBottom="20px"
        >
          <Button
            onClick={() => handleChange("Si")}
            bg={data?.dial_type === "Si" ? "#dc3545" : "#dc354580"}
            color="white"
            _hover={{
              bg: data?.dial_type === "Si" ? "#c82333" : "#dc3545"
            }}
            _active={{
              bg: "#c82333"
            }}
            fontSize={{ base: "16px", sm: "15px", md: "16px" }}
            minH={{ base: "50px", sm: "48px", md: "44px" }}
            px={{ base: "20px", sm: "18px", md: "20px" }}
            fontWeight="600"
            borderRadius="6px"
            border={data?.dial_type === "Si" ? "2px solid #c82333" : "2px solid #dc3545"}
            boxShadow={data?.dial_type === "Si" ? "0 2px 4px rgba(220, 53, 69, 0.3)" : "none"}
            transition="all 0.2s"
            isLoading={loading}
            disabled={loading}
            width="100%"
            cursor={loading ? "not-allowed" : "pointer"}
          >
            Si
          </Button>
          <Button
            onClick={() => handleChange("No")}
            bg={data?.dial_type === "No" ? "#28a745" : "#28a74580"}
            color="white"
            _hover={{
              bg: data?.dial_type === "No" ? "#218838" : "#28a745"
            }}
            _active={{
              bg: "#218838"
            }}
            fontSize={{ base: "16px", sm: "15px", md: "16px" }}
            minH={{ base: "50px", sm: "48px", md: "44px" }}
            px={{ base: "20px", sm: "18px", md: "20px" }}
            fontWeight="600"
            borderRadius="6px"
            border={data?.dial_type === "No" ? "2px solid #218838" : "2px solid #28a745"}
            boxShadow={data?.dial_type === "No" ? "0 2px 4px rgba(40, 167, 69, 0.3)" : "none"}
            transition="all 0.2s"
            isLoading={loading}
            disabled={loading}
            width="100%"
            cursor={loading ? "not-allowed" : "pointer"}
          >
            No
          </Button>
        </Box>
      </Td>
    </Tr>
  );
};

export default TbodyItemsProfile;
